import BadWords from "../Assets/BadWords.json";

export const BLOCKED_COMMENT_MESSAGE =
    "Please remove blocked language before submitting your comment.";

interface BlockedWordRule {
    tokens: string[];
    prefixLastToken: boolean;
}

const tokenize = (text: string): string[] =>
    text.toLowerCase().match(/[\p{L}\p{N}]+/gu) ?? [];

const blockedWordRules = (BadWords as string[])
    .map<BlockedWordRule>((entry) => ({
        tokens: tokenize(entry),
        prefixLastToken: entry.toLowerCase() === "masterbat*",
    }))
    .filter((rule) => rule.tokens.length > 0);

const matchesRuleAt = (
    textTokens: string[],
    start: number,
    rule: BlockedWordRule
): boolean => {
    if (start + rule.tokens.length > textTokens.length) return false;

    return rule.tokens.every((ruleToken, index) => {
        const textToken = textTokens[start + index];
        const isPrefixToken =
            rule.prefixLastToken && index === rule.tokens.length - 1;

        return isPrefixToken
            ? textToken.startsWith(ruleToken)
            : textToken === ruleToken;
    });
};

export function ContainsBadWords(text: string): boolean {
    const textTokens = tokenize(text);
    if (textTokens.length === 0) return false;

    return blockedWordRules.some((rule) =>
        textTokens.some((_, start) => matchesRuleAt(textTokens, start, rule))
    );
}

export function IsCommentValid(text: string) {
    const regex = new RegExp(
        "^((?!(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:\\/?#[\\]@!\\$&'\\(\\)\\*\\+,;=.]+).)([A-Za-z0-9!\\-.,;_#£&$%?\\u00C0-\\u00D6\\u00D8-\\u00f6\\u00f8-\\u00ff\\s]*)$",
        "gm"
    );

    return regex.test(text);
}
